export enum BookingStatus {
  PAID = 'PAID',

  UNPAID = 'UNPAID',

  CANCELLED = 'CANCELLED',
}
